module.exports = __webpack_public_path__ + "media/images/direct_message_personal_empty-8ff7a038.svg";